import { render } from "./ClientCreationModal.vue?vue&type=template&id=badb5c2e&scoped=true"
import script from "./ClientCreationModal.vue?vue&type=script&lang=js"
export * from "./ClientCreationModal.vue?vue&type=script&lang=js"

import "./ClientCreationModal.vue?vue&type=style&index=0&id=badb5c2e&scoped=true&lang=css"

import exportComponent from "G:\\dev\\OSPanel\\domains\\arenda-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-badb5c2e"]])

export default __exports__